import styled from 'styled-components';
export var UIA11yVisuallyHidden = styled.div.withConfig({
  displayName: "UIA11yVisuallyHidden",
  componentId: "sc-16eblg2-0"
})(["position:absolute !important;width:1px !important;height:1px !important;padding:0 !important;margin:-1px !important;overflow:hidden !important;clip:rect(0,0,0,0) !important;white-space:nowrap !important;border:0 !important;"]);